export default {
    list: {
        method: "POST",
        url: '/admin/log/list',
        name: 'banner新增'
    },
}